<template>
	<div class="cms-wrapper flex">
		<input type="text" name="username" style="display:none">
		<input type="password" name="password" style="display:none"/>
		<div class="cms-nav flex-column">
			<div class="cms-logo flex-center">
				<img :src="systemConfig.oms_logo" alt="">
			</div>
			
			<ul class="flex-grow">
				<li v-for="(item,i) in navList" :key="i" class="flex-center-cross" :class="{'z-crt': aliveNavItem == i}" @click="navHandle(item, i)">
					<i class="tf tf-fw" :class="[item.menu_ico || 'tf-nav-home']"></i>
					<span>{{item.menu_name}}</span>
				</li>
			</ul>
		</div>
		
		<div v-if="menuList && menuList.child_menu_list" class="cms-menu flex-column">
			<div class="cms-menu-name">{{menuList.menu_subname}}</div>
			<div class="cms-menu-list flex-grow">
				<div v-for="(group, i) in menuList.child_menu_list" :key="i">
					<div v-if="group.child_menu_list" class="cms-menu-group-wrapper">
						<div class="cms-menu-group">{{group.menu_name}}</div>
						<div v-for="(item, j) in group.child_menu_list" :key="j" class="cms-menu-item" :class="{'z-crt': alivePage == item.menu_unique_key}" @click="navHandle(item)">{{item.menu_name}}</div>
					</div>
					<div v-else class="cms-menu-item" :class="{'z-crt': alivePage == group.menu_unique_key}" @click="navHandle(group)">{{group.menu_name}}</div>
				</div>
			</div>
		</div>
		
		<div class="flex-grow flex-column">
			<div class="cms-header">
				<div class="flex-between-center">
					<div class="cms-search flex-center flex-grow">
						<i class="tf tf-search"></i>
						<input v-model="searchKeyword" class="flex-grow" type="text" placeholder="搜索系统功能" @click.stop="showSearchList = searchList.length > 0">
						
						<ul v-show="showSearchList">
							<li v-for="(item, i) in searchList" :key="i" @click="navigateTo({name: item.menu_unique_key})">
								<p>{{item.menu_name}}</p>
								<p><span><i class="tf tf-address"></i>{{item.menu_path}}</span></p>
							</li>
						</ul>
					</div>
					
					<div class="flex">
						<div v-for="(item, i) in handleList" :key="i" class="cms-handle flex-center" :title="item.name" @click="item.handle()">
							<i class="tf" :class="[item.icon]"></i>
						</div>
						<div class="cms-user flex-center">
							<div class="icon flex-center"><i class="tf tf-user"></i></div>
							<span class="name">{{userInfo.name}}</span>
							<i class="tf tf-tri-down"></i>
							
							<div class="user-handle">
								<div class="item" @click="$refs.resetPsw.open()">修改密码</div>
								<!-- <div class="item flex-between-center">
									主题皮肤<i class="tf tf-tri-right"></i>
									<div class="theme-list">
										<div v-for="(item, i) in themeList" :key="i" class="item" @click="$store.commit('setTheme', item.value)">{{item.name}}</div>
									</div>
								</div> -->
								<div class="item" @click="logout">安全退出</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="cms-tab-list flex">
					<div class="indicator left flex-center" @click="tabMoveHandle(1)"><i class="tf tf-angle-left"></i></div>
					<div class="tab home flex-center" :class="{'z-crt': alivePage == 'home'}" @click="navigateTo({name: 'home'})">
						<i class="tf tf-house"></i>
					</div>
					<div ref="tabWrapper" class="list flex-grow">
						<ul ref="tabList" :style="{'left': `${tabListSeat}px`}">
							<li ref="tab" v-for="(item,i) in tabList" :key="i" class="tab" :class="{'z-crt': alivePage == item.key}" @click="navigateTo(item.path || {name: item.key})" @contextmenu.prevent="showRightMenu(item, i)">
								<div class="flex-between-center">
									<span>{{item.name}}</span>
									<a class="tf tf-cross" @click.stop="closePage(item.key)"></a>
								</div>
							</li>
						</ul>
					</div>
					<div class="indicator right flex-center" @click="tabMoveHandle(-1)"><i class="tf tf-angle-right"></i></div>
					<div v-show="rightMenuTab" class="right-menu" :style="{'left': rightMenuPosition}">
						<div v-for="(item, i) in rightMenuList" :key="i" class="item" @click="rightMenuHandle(item.value)">{{item.name}}</div>
					</div>
				</div>
			</div>
			
			<div class="cms-pages flex-grow">
				<keep-alive :include="keepAlive">
					<router-view v-if="!refreshPage || refreshPage != alivePage" ref="routerView"></router-view>
				</keep-alive>
			</div>
		</div>
		
		<c-dialog ref="resetPsw" title="修改密码" width="600" @resolve="resetPassword" @close="$refs.resetPswForm.clear()">
			<c-form ref="resetPswForm">
				<c-form-item type="password" label="旧密码" name="old_pwd" required></c-form-item>
				<c-form-item type="password" label="新密码" name="user_pwd" required></c-form-item>
				<c-form-item type="password" label="确认密码" name="confirm_pwd" required></c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import CryptoJs from '@/assets/script/lib/crypto-js'
	import global from '@/assets/script/function.js'
	import {mapState} from 'vuex'
	
	export default {
		name: 'cmsWrapper',
		
		data() {
			return {
				themeList: [{
					name: '中国红',
					value: 'red'
				}, {
					name: '科技蓝',
					value: 'blue'
				}, {
					name: '环保绿',
					value: 'green'
				}, {
					name: '玉烟紫',
					value: 'purple'
				}],
				
				searchKeyword: '',
				showSearchList: false,
				searchList: [],
				
				handleList: [{
					name: '全屏显示',
					icon: 'tf-full-screen',
					handle() {
						var el = document.documentElement;
							el.requestFullscreen || el.mozRequestFullScreen || el.webkitRequestFullscreen || el.msRequestFullScreen
								? el.requestFullscreen() || el.mozRequestFullScreen() ||  el.webkitRequestFullscreen() || el.msRequestFullscreen()
								: null;
					}
				}, {
					name: '任务中心',
					icon: 'tf-task',
					handle: () => {
						this.navigateTo({name: 'm_task_center_list'})
					}
				// }, {
				// 	name: '前往商城',
				// 	icon: 'tf-mall',
				// 	handle: () => {
				// 		window.open(this.systemConfig.pc_mall_url);
				// 	}
				}],
				
				tabList: [],
				tabListSeat: 0,
				
				refreshPage: '',
				rightMenuList: [{
					name: '刷新',
					value: 'refresh'
				}, {
					name: '关闭',
					value: 'close'
				}, {
					name: '关闭其他标签',
					value: 'closeOther'
				}, {
					name: '关闭右侧标签',
					value: 'closeRight'
				}, {
					name: '全部关闭',
					value: 'closeAll'
				}],
				rightMenuTab: false,
				rightMenuPosition: 0,
				
				aliveNavItem: -1,
				alivePage: '',
				
				historyList: []
			};
		},
		
		computed: {
			...mapState(['systemConfig', 'userInfo', 'navList']),
			
			keepAlive() {
				return ['home'].concat(Array.from(this.tabList.filter(item => item.key != this.refreshPage), item => {
					return item.key;
				}));
			},
			
			navLibrary() {
				return Array.from(this.navList, item => {
					let keys = item.menu_unique_key ? [{
						key: item.menu_unique_key,
						name: item.menu_name
					}] : [];
					!function poll(list) {
						if (!list) return;
						list.forEach(item => {
							if (item.menu_unique_key) {
								keys.push({
									key: item.menu_unique_key,
									name: item.menu_name
								});
							}
							poll(item.child_menu_list);
						});
					}(item.child_menu_list);
					return keys;
				});
			},
			
			menuList() {
				return this.navList[this.aliveNavItem];
			}
		},
		
		watch: {
			$route(val) {
				this.historyList.push({
					path: val.fullPath,
					name: val.name
				});
				this.updateAlivePage();
			},
			
			searchKeyword() {
				this.searchHandle();
			},
			
			navList() {
				this.updateAlivePage();
			}
		},
		
		mounted() {
			this.updateAlivePage();
			
			this._resizeHandler = global.throttle(() => {
				this.tabMoveHandle();
			}, 200, false)
			
			window.addEventListener('resize', this._resizeHandler);
			window.addEventListener('click', () => {
				this.showSearchList = false;
				this.rightMenuTab = false;
			});
		},
		
		beforeDestroy() {
			window.removeEventListener('resize', this._resizeHandler);
		},

		methods: {
			navHandle(item, index) {
				var that = this;
				
				if (index !== undefined) {
					this.aliveNavItem = index;
					
					if (item.child_menu_list) {
						return;
					}
				}
				
				!function poll(item) {
					if (item.menu_unique_key) {
						if (item.menu_unique_key == 'm_oss_manage') {
							that.navigateTo('/oss_manage', true);
							return;
						}
						
						that.navigateTo({
							name: item.menu_unique_key
						});
						
						that.request({
							url: '/workbench/common_func_add',
							data: {
								name: item.menu_name,
								key: item.menu_unique_key
							},
							fail: () => {
								return false;
							}
						});
					} else if (item.child_menu_list) {
						poll(item.child_menu_list[0]);
					}
				}(item.child_menu_list ? item.child_menu_list[0] : item)
			},
			
			searchHandle: global.debounce(function() {
				this.searchRequest && this.searchRequest.abort();
				
				if (this.searchKeyword) {
					this.searchRequest = this.request({
						url: '/system_menu/user_search',
						data: {
							menu_keyword: this.searchKeyword.trim()
						},
						success: data => {
							this.showSearchList = data.length > 0;
							this.searchList = data;
						}
					});
				} else {
					this.showSearchList = false;
					this.searchList = [];
				}
			}, 200, false),
			
			tabMoveHandle(dir) {
				this.$nextTick(() => {
					var wrapper = this.$refs.tabWrapper.offsetWidth,
						list = this.$refs.tabList.offsetWidth,
						left = Math.abs(this.tabListSeat),
						maxLeft = list - wrapper;
						
					if (dir) {
						if (maxLeft > 0) {
							this.tabListSeat += dir * parseInt(wrapper * 0.6);
							this.tabListSeat = this.tabListSeat > 0 ? 0 : this.tabListSeat < -maxLeft ? -maxLeft : this.tabListSeat;
						}
						return;
					}
						
					var $crt = this.$refs.tab && this.$refs.tab.find(item => {
						return item.getAttribute('class').includes('z-crt');
					});
					
					if ($crt && maxLeft > 0) {
						if ($crt.offsetLeft < left) {
							this.tabListSeat = -$crt.offsetLeft;
						} else if ($crt.offsetLeft > wrapper + left - $crt.offsetWidth) {
							this.tabListSeat = wrapper - $crt.offsetWidth - $crt.offsetLeft;
						} else {
							this.tabListSeat = this.tabListSeat < -maxLeft ? maxLeft < 0 ? 0 : -maxLeft : this.tabListSeat;
						}
					} else {
						this.tabListSeat = this.tabListSeat < -maxLeft ? maxLeft < 0 ? 0 : -maxLeft : this.tabListSeat;
					}
				});
			},
			
			updateAlivePage(route = this.$route) {
				let page, index = this.navLibrary.findIndex(nav => {
					page = nav.find(item => {
						return item.key == route.name;
					});
					return !!page;
				});
				this.aliveNavItem = index > -1 ? index : this.aliveNavItem;
				this.alivePage = route.name;
				
				if (route.name != 'home') {
					var tabIndex = this.tabList.findIndex(item => item.key == route.name);
					page = page || {
						key: route.name,
						path: route.fullPath,
						name: route.meta.title || route.name
					}
					if (tabIndex == -1) {
						this.tabList.push(page);
					} else {
						this.tabList[tabIndex] = page;
					}
					
					this.tabMoveHandle();
				}
			},
			
			closePage(keys, back = true) {
				keys = typeof keys == 'string' ? [keys] : keys;
				for (let i = keys.length - 1; i >= 0; i--) {
					let key = keys[i];
					var index = this.tabList.findIndex(item => item.key == key)
					this.tabList.splice(index, 1);
				}
				if (back && keys.includes(this.$route.name)) {
					for (var i = this.historyList.length - 1; i >= 0; i--) {
						var history = this.historyList[i];
						if (this.tabList.find(item => item.key == history.name)) {
							this.historyList.splice(i + 1);
							this.navigateTo(history.path);
							break;
						}
					}
					
					if (i == -1) {
						this.navigateTo('/');
					}
				} else {
					this.tabMoveHandle();
				}
			},
			
			closeAlivePage() {
				this.closePage(this.alivePage, false);
			},
			
			showRightMenu(item, index) {
				this.rightMenuTab = item;
				this.rightMenuPosition = this.$refs.tab[index].offsetLeft + this.tabListSeat + 75 + 'px';
			},
			
			rightMenuHandle(type) {
				var keys;
				switch (type) {
				case 'refresh':
					this.refreshPage = this.rightMenuTab.key;
					setTimeout(() => {
						this.refreshPage = '';
					});
					break;
					
				case 'close':
					keys = [this.rightMenuTab.key];
					break;
					
				case 'closeOther':
					keys = Array.from(this.tabList.filter(item => item != this.rightMenuTab), item => item.key);
					break;
					
				case 'closeRight':
					var index = this.tabList.findIndex(item => item == this.rightMenuTab);
					keys = Array.from(this.tabList.filter((item, i) => i > index), item => item.key);
					break;
					
				case 'closeAll':
					keys = Array.from(this.tabList, item => item.key);
				}
				
				keys && keys.length && this.closePage(keys);
			},
			
			logout() {
				this.$confirm({
					text: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
						old_pwd: '请填写旧密码',
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							word: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							word: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						data.old_pwd = CryptoJs.MD5(data.old_pwd).toString();
						data.user_pwd = CryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							text: '密码修改成功',
							icon: 'success'
						});
						this.$refs.resetPsw.close();
					}
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme';
	
	.cms {
		&-wrapper {
			width: 100vw;
			height: 100vh;
			overflow: hidden;
		}
		
		&-logo {
			height: 75px;
		}
		
		&-nav {
			width: 100px;
			color: #fff;
			theme-background(lesser);
			
			li {
				height: 45px;
				padding: 0 10px;
				font-size: 14px;
				font-weight: bold;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover
				&.z-crt {
					theme-background(main);
				}
				
				.tf {
					margin-right: 4px;
					font-size: 18px;
					font-weight: normal;
				}
			}
		}
		
		&-menu {
			width: 140px;
			border-right: 1px solid #ddd;
			background: #fff;
			
			&-name {
				height: 60px;
				border-bottom: 1px solid #ddd;
				margin-bottom: 10px;
				line-height: 65px;
				font-size: 16px;
				font-weight: bold;
				text-indent: 16px;
			}
			
			&-list {
				overflow: auto;
			}
			
			&-group {
				margin-top: 5px;
				line-height: 40px;
				font-size: 13px;
				text-indent: 16px;
				color: #aaa;
				
				&-wrapper {
					.cms-menu-item {
						text-indent: 34px;
						
						&:before {
							content: '';
							position: absolute;
							left: 22px;
							top: 50%;
							width: 3px;
							height: 3px;
							border: 1px solid #444;
							transform: translate(0,-50%);
						}
					}
				}
			}
				
			&-item {
				position: relative;
				line-height: 40px;
				text-indent: 16px;
				color: #444;
				cursor: pointer;
				
				&:hover {
					theme-color(main);
				}
				
				&.z-crt {
					font-weight: bold;
					background: #F5F5F5;
				}
			}
		}
		
		&-header {
			z-index: 100;
			position: relative;
			background: #fff;
			box-shadow: 0 1px 3px 0 rgba(0,0,0,.1);
		}
		
		&-search {
			position: relative;
			max-width: 600px;
			height: 34px;
			border-radius: 2px;
			margin: 0 15px;
			background: #F5F5F5;
			
			.tf-search {
				margin: 0 12px;
				font-size: 14px;
				color: #bbb;
			}
			
			input {
				height: 100%;
				margin-right: 12px;
			}
			
			ul {
				z-index: 11;
				position: absolute;
				left: 0;
				right: 0;
				top: 100%;
				max-height: 500px;
				border: 1px solid #eee;
				overflow: auto;
				background: #fff;
				box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
				
				li {
					padding: 6px 18px;
					font-size: 13px;
					color: #333;
					line-height: 24px;
					cursor: pointer;
				
					&:hover {
						color: #fff;
						theme-background(main);
					
						span {
							color: #ddd;
						}
					}
					
					&:nth-child(n+2) {
						border-top: 1px solid #eee;
					}
					
					span {
						color: #999;
						
						.tf {
							margin-right: 5px;
						}
					}
				}
			}
		}
		
		&-handle {
			width: 56px;
			height: 60px;
			font-size: 18px;
			cursor: pointer;
			transition: all .3s ease;
			
			&:hover {
				background: #F5F5F5;
			}
		}
		
		&-user {
			position: relative;
			height: 60px;
			padding: 0 20px;
			cursor: pointer;
			transition: all .3s ease;
			
			&:hover {
				background: #F5F5F5;
				
				.user-handle {
					display: block;
				}
			}
			
			.icon {
				width: 34px;
				height: 34px;
				border-radius: 100%;
				font-size: 15px;
				color: #fff;
				background: #000;
			}
			
			.name {
				margin: 0 6px 0 10px;
				font-size: 13px;
				font-weight: bold;
			}
			
			> .tf {
				font-size: 12px;
			}
			
			.user-handle {
				display: none;
				z-index: 12;
				position: absolute;
				left: 0;
				right: 0;
				top: 100%;
				padding: 8px 0;
				background: #fff;
				box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
				
				.item {
					position: relative;
					padding: 0 10px 0 16px;
					line-height: 36px;
					font-size: 13px;
					color: #333;
					
					&:hover {
						background: #F5F5F5;
						theme-color(main);
						
						.theme-list {
							display: block;
						}
					}
					
					.tf {
						font-size: 12px;
						color: #333;
					}
					
					.theme-list {
						display: none;
						position: absolute;
						right: 100%;
						top: 0;
						width: 100px;
						padding: 8px 0;
						background: #fff;
						box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
					}
				}
			}
		}
		
		&-tab-list {
			position: relative;
			height: 40px;
			border-top: 1px solid #eee;
			
			.list {
				z-index: 10;
				position: relative;
				overflow: hidden;
				background: #fff;
			
				ul {
					float: left;
					position: relative;
					font-size: 0;
					white-space: nowrap;
					transition: left .2s ease;
					
					li {
						display: inline-block;
						min-width: 80px;
						
						div {
							height: 100%;
						}
					}
				}
			}
			
			.tab {
				&.home {
					box-sizing: border-box;
					min-width: auto;
					width: 45px;
					font-size: 18px;
				}
				
				position: relative;
				height: 40px;
				border-right: 1px solid #ddd;
				padding: 0 10px;
				cursor: pointer;
				
				&:hover {
					background: #FAFAFA;
				}
				
				&.z-crt {
					span {
						font-weight: bold;
					}
					
					&:before {
						width: 100%;
						theme-background(main);
					}
				}
				
				span {
					margin-right: 14px;
					font-size: 14px;
					white-space: nowrap;
					color: #444;
				}
				
				a {
					padding: 2px;
					border-radius: 100%;
					font-size: 12px;
					color: #aaa;
					
					&:hover {
						background: #EB0000;
						color: #fff;
					}
				}
				
				&:before {
					content: '';
					position: absolute;
					left: 50%;
					top: 0;
					width: 0;
					height: 2px;
					transform: translate(-50%,0);
					transition: width .15s ease;
				}
			}
			
			.indicator {
				z-index: 10;
				position: relative;
				width: 30px;
				cursor: pointer;
				
				&.left {
					border-right: 1px solid #ddd;
				}
				
				&.right {
					border-left: 1px solid #ddd;
					margin-left: -1px;
				}
				
				&:hover {
					font-weight: bold;
					background: #FAFAFA;
				}
			}
				
			.right-menu {
				box-sizing: border-box;
				z-index: 11;
				position: absolute;
				left: 76px;
				top: 40px;
				width: 160px;
				border: 1px solid #ddd;
				padding: 10px 0;
				font-size: 13px;
				color: #666;
				background: #fff;
				box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
				
				.item {
					padding: 0 20px;
					line-height: 36px;
					cursor: pointer;
					
					&:hover {
						background: #F5F5F5;
						theme-color(main);
					}
				}
			}
		}
		
		&-pages {
			position: relative;
			overflow-x: hidden;
			overflow-y: auto;
		}
	}
</style>